export enum EventEvent {
  CREATED = 'TL_EVENT_CREATED',
  UPDATED = 'TL_EVENT_UPDATED',
  DELETED = 'TL_EVENT_DELETED',
  GENERATE_RECURRING = 'TL_EVENT_GENERATE_RECURRING',
  UPDATE_RECURRING = 'TL_EVENT_UPDATE_RECURRING',
}

export enum EventError {
  ID_REQUIRED = 'id required',
  EVENT_ID_REQUIRED = 'eventId is required',
  EVENT_NOT_FOUND = 'event not found',
  VENUE_NOT_FOUND = 'venue not found',
  VISIBILITY_INVALID = 'invalid visibility',
  VISIBILITY_HIGHER_THAN_VENUE = 'invalid visibility, cannot be higher than private venue',
}

export enum EventSort {
  NAME_ASC = 'name',
  NAME_DSC = '-name',
  DATE_START_ASC = 'dateStart',
  DATE_START_DSC = '-dateStart',
  DATE_ASC = 'date',
  DATE_DSC = '-date',
  PAGE_VIEWS_DSC = '-analytics.pageViews',
}
